import { render, staticRenderFns } from "./ColorCom.vue?vue&type=template&id=420f1fcc&scoped=true"
import script from "./ColorCom.vue?vue&type=script&lang=js"
export * from "./ColorCom.vue?vue&type=script&lang=js"
import style0 from "./ColorCom.vue?vue&type=style&index=0&id=420f1fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420f1fcc",
  null
  
)

export default component.exports